module.exports = __webpack_public_path__ + "media/img/private-venue/bg-stats-28faa609343bdddd046401b40ced7727.png";